import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useApi } from '../../providers/ApiContext';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Copyright from '../../components/common/Copyright';
import { Alert } from '@mui/material';
import { ReactComponent as Logo } from '../../components/common/asset/logo.svg'; 

function RegistrationPage() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);
    const navigate = useNavigate();
    const { isAuthenticated, performRegistration } = useApi();

    const handleRegistration = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        await performRegistration(
            data.get('fullName'),
            data.get('email'),
            data.get('password'),
            (user) => {
                navigate('/teams');
            },
            (error) => {
                if (error.response) {
                    setErrorMessage(error.response.data.message);
                } else {
                    setErrorMessage('Oops! Something went wrong. Please try again later.');
                }
            }
        );
    };

    if (isAuthenticated) {
        return <Navigate to="/teams" />;
    }

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
                sx={{
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box display="flex" alignItems="center">
                    <Logo height={80} width={80} fill='black' sx={{ display: { xs: 'none', md: 'flex' }, color: 'white' }} />

                    <Typography variant="h4" sx={{ marginLeft: 2, fontWeight: 'bold' }}>
                        {process.env.REACT_APP_WEBSITE_NAME}
                    </Typography>
                </Box>
                <Avatar sx={{ m: 1, mt: 8, bgcolor: 'secondary.main' }}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Sign up
                </Typography>

                {errorMessage && errorMessage.trim() !== '' && (
                    <Alert severity="error" sx={{ width: '100%', marginTop: '10px' }}>
                        {errorMessage}
                    </Alert>
                )}

                <Box component="form" noValidate onSubmit={handleRegistration} sx={{ mt: 3 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                required
                                fullWidth
                                id="fullName"
                                label="Full Name"
                                name="fullName"
                                autoComplete="full-name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="new-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Sign Up
                    </Button>
                    <Grid container justifyContent="center">
                        <Grid item>
                            <Link href="/login" variant="body2">
                                Already have an account? Sign in
                            </Link>
                        </Grid>
                    </Grid>
                </Box>
                <Copyright sx={{ mt: 8, mb: 15 }} />
            </Box>
        </Container>
    );
}

export default RegistrationPage;
